import {
  AiTurn,
  ChatHistoryParams,
  ChatHistoryResponse,
  GetAiConversationsParams,
  GetAiConversationsResponse,
  GetAiConversationTurnsParams,
  GetAiConversationTurnsResponse,
  SendFilesResponse,
} from '@/types/supportChat';

import { api } from '../api';

export const supportChatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatHistory: builder.query<ChatHistoryResponse, ChatHistoryParams>({
      query: (params) => ({
        url: '/v2/support/chat/get-history',
        params,
      }),
    }),
    sendFiles: builder.mutation<SendFilesResponse, { session_id?: string; files: FormData }>({
      query: ({ session_id, files }) => ({
        url: '/v2/support/chat/send-files',
        method: 'POST',
        body: files,
        params: session_id ? { session_id } : undefined,
      }),
    }),
    createAiTurn: builder.mutation<
      Partial<AiTurn>,
      { conversation_id: string; message: string; idempotencyKey: string }
    >({
      query: ({ conversation_id, message, idempotencyKey }) => ({
        url: `${
          (import.meta.env.VITE_AI_AGENT_URL as string) ?? ''
        }/v2/agents/knowledge/conversations/${conversation_id}/turns`,
        method: 'POST',
        body: { message },
        headers: {
          'Idempotency-Key': idempotencyKey,
        },
      }),
    }),
    getAiConversations: builder.query<GetAiConversationsResponse, GetAiConversationsParams>({
      query: (params) => ({
        url: `${
          (import.meta.env.VITE_AI_AGENT_URL as string) ?? ''
        }/v2/agents/knowledge/conversations`,
        params,
      }),
    }),
    createAiConversation: builder.mutation<
      { conversation_id: string; created_at: string; updated_at: string },
      { idempotencyKey?: string }
    >({
      query: ({ idempotencyKey }) => ({
        url: `${
          (import.meta.env.VITE_AI_AGENT_URL as string) ?? ''
        }/v2/agents/knowledge/conversations`,
        method: 'POST',
        body: {},
        headers: {
          'Idempotency-Key': idempotencyKey,
        },
      }),
    }),
    getAiConversationTurns: builder.query<
      GetAiConversationTurnsResponse,
      GetAiConversationTurnsParams
    >({
      query: ({ conversation_id, order = 'asc', limit = 100, before_turn_no, after_turn_no }) => ({
        url: `${
          (import.meta.env.VITE_AI_AGENT_URL as string) ?? ''
        }/v2/agents/knowledge/conversations/${conversation_id}/turns`,
        params: {
          order,
          limit,
          ...(before_turn_no ? { before_turn_no } : {}),
          ...(after_turn_no ? { after_turn_no } : {}),
        },
      }),
    }),
  }),
});

export const {
  useGetChatHistoryQuery,
  useSendFilesMutation,
  useCreateAiTurnMutation,
  useGetAiConversationsQuery,
  useCreateAiConversationMutation,
  useGetAiConversationTurnsQuery,
} = supportChatApi;
